export default __webpack_public_path__ + "static/carousel-18-e6056c5fe8af2395bbd481ff75f22d36.jpg";